export const CUSTOM_DATA_NAMESPACE = 'webauto_fms';
// カスタムデータ の key_name
export const CUSTOM_DATA_KEY = {
  SCHEDULE_TEMPLATE: 'schedule_template',
  REMOTE_MONITORING_SETTINGS: 'remote_monitoring_settings',
} as const;
